"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLastMatchingTurns = exports.handValuesMatch = exports.handValuesMatchExactly = exports.getAllCardsInPlay = exports.isTurnTrick = exports.getRankAndScore = exports.normaliseWildcards = exports.hasCards = exports.assignDeltTo = exports.sortHand = exports.collapseHand = exports.isPureSet = exports.toValues = exports.getOppositeRankLabel = exports.getRankLabel = exports.getOppositeRank = void 0;
const constants_1 = require("./constants");
// eslint-disable-next-line no-duplicate-imports
const types_1 = require("./types");
function getOppositeRank(rank) {
    if (!rank) {
        return null;
    }
    switch (rank) {
        case types_1.RankEnum.president:
            return types_1.RankEnum.asshole;
        case types_1.RankEnum.vicepresident:
            return types_1.RankEnum.viceasshole;
        case types_1.RankEnum.viceasshole:
            return types_1.RankEnum.vicepresident;
        case types_1.RankEnum.asshole:
            return types_1.RankEnum.president;
    }
}
exports.getOppositeRank = getOppositeRank;
function getRankLabel(rank) {
    switch (rank) {
        case types_1.RankEnum.president:
            return "President";
        case types_1.RankEnum.vicepresident:
            return "Vice-President";
        case types_1.RankEnum.viceasshole:
            return "Vice-Asshole";
        case types_1.RankEnum.asshole:
            return "Asshole";
    }
    return "";
}
exports.getRankLabel = getRankLabel;
function getOppositeRankLabel(rank) {
    const oppositeRank = getOppositeRank(rank);
    return getRankLabel(oppositeRank);
}
exports.getOppositeRankLabel = getOppositeRankLabel;
function toValues(cards) {
    return cards.map((c) => c.value);
}
exports.toValues = toValues;
function isPureSet(cards) {
    const values = toValues(cards);
    const unique = new Set(values);
    return unique.size === 1;
}
exports.isPureSet = isPureSet;
function collapseHand(cards, wildCards) {
    const values = toValues(normaliseWildcards(cards, wildCards));
    const unique = new Set(values);
    if (unique.size > 1) {
        throw new Error(`Hand values are mixed ${Array.from(unique)}`);
    }
    return values[0];
}
exports.collapseHand = collapseHand;
function sortHand(hand) {
    return hand.sort((a, z) => constants_1.CARD_ORDER.indexOf(a.value) -
        constants_1.CARD_ORDER.indexOf(z.value));
}
exports.sortHand = sortHand;
function assignDeltTo(playerId, hand) {
    return hand.map((c) => ((c.deltTo = playerId), c));
}
exports.assignDeltTo = assignDeltTo;
const isCard = (value) => (card) => card.value === value;
const notCard = (value) => (card) => card.value !== value;
const hasCards = (cards) => (hand) => cards.every((card) => hand.some(isCard(card.value)));
exports.hasCards = hasCards;
function normaliseWildcards(hand, wild = [{ value: "joker" }]) {
    const hasWild = (0, exports.hasCards)(wild);
    if (hasWild(hand)) {
        const jokers = hand.filter(isCard("joker"));
        const nonJokers = hand.filter(notCard("joker"));
        if (!nonJokers.length) {
            return hand; // we only have jokers
        }
        const unique = new Set(nonJokers.map((card) => card.value));
        if (unique.size > 1) {
            throw new Error("Invalid Hand: Jokers cannot be used with mixed card values");
        }
        return [
            ...nonJokers,
            ...jokers.map(() => {
                return {
                    value: nonJokers[0].value
                };
            })
        ];
    }
    return hand;
}
exports.normaliseWildcards = normaliseWildcards;
function getRankAndScore(
/**
 * 0 Indexed
 */
finishingIdx, 
/**
 * 1 Indexed
 */
totalPlayers) {
    // Finished First
    if (finishingIdx === 0) {
        return [types_1.RankEnum.president, 2];
        // Finished Last
    }
    else if (finishingIdx + 1 === totalPlayers) {
        return [types_1.RankEnum.asshole, -2];
        // We have 4 or more players
    }
    else if (totalPlayers > 3) {
        // Finished Second
        if (finishingIdx === 1) {
            return [types_1.RankEnum.vicepresident, 1];
            // Finished Second Last
        }
        else if (totalPlayers - 2 === finishingIdx) {
            return [types_1.RankEnum.viceasshole, -1];
        }
    }
    return [types_1.RankEnum.unranked, 0];
}
exports.getRankAndScore = getRankAndScore;
function isTurnTrick(t) {
    return t.type === "trick";
}
exports.isTurnTrick = isTurnTrick;
function getAllCardsInPlay(turns) {
    return turns
        .filter(isTurnTrick)
        .map((t) => { var _a, _b; return (_b = (_a = t.__original_turn) === null || _a === void 0 ? void 0 : _a.cards) !== null && _b !== void 0 ? _b : t.cards; });
}
exports.getAllCardsInPlay = getAllCardsInPlay;
const handValuesMatchExactly = (handA, handB) => handA.length === handB.length &&
    handA.every((c, i) => c.value === handB[i].value);
exports.handValuesMatchExactly = handValuesMatchExactly;
const handValuesMatch = (handA, handB) => {
    if (isPureSet(handA) && isPureSet(handB)) {
        return toValues(handA)[0] === toValues(handB)[0];
    }
    return false;
};
exports.handValuesMatch = handValuesMatch;
function getLastMatchingTurns(turnCards) {
    const run = [];
    const reversed = turnCards.slice().reverse();
    let lastSeen = undefined;
    for (const hand of reversed) {
        if ((!lastSeen && isPureSet(hand)) ||
            (lastSeen && (0, exports.handValuesMatch)(lastSeen, hand))) {
            run.push(hand);
        }
        else {
            break;
        }
        lastSeen = hand;
    }
    return run;
}
exports.getLastMatchingTurns = getLastMatchingTurns;
//# sourceMappingURL=utils.js.map